import React from 'react';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, element, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { getLostProps, propagateProps } from '@philips-internal/oswald-ui-utils';
import { CardContainerFooterAPI } from './card-container-footer-api.js';
import './card-container-footer.css';
const FooterContainer = {
    name: '',
};
function CardContainerFooter(props) {
    const lostProps = getLostProps(CardContainerFooter.propTypes, props);
    return (React.createElement(Container, { className: "c-card-container-footer", uuid: props.uuid }, propagateProps(props.children, { ...lostProps })));
}
CardContainerFooter.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    uuid: string,
};
CardContainerFooter.defaultProps = {
    uuid: '',
};
const awesomeProps = {
    api: CardContainerFooterAPI,
    container: [FooterContainer],
    type: ComponentType.LAYOUT,
};
AwesomeComponent(awesomeProps)(CardContainerFooter);
export { CardContainerFooter, };
//# sourceMappingURL=card-container-footer.js.map